export const coreCompetence = ['Agility', 'Market-Driven Development', 'User Experience (UX)', 'Developer Experience (DX)', 'Empathy-Driven Design', 'Automation as a Force Multiplier', 'Fail Fast - Learn Faster', 'Bias For Action'];
